import type { ImportAdapter } from './types';
import { contactAdapter } from './adapters/contact.adapter';
import { customDataAdapter } from './adapters/custom-data.adapter';
import { campaignAutomationAdapter } from './adapters/campaign-automation.adapter';
import { campaignBulkAdapter } from './adapters/campaign-bulk.adapter';
import { templateAdapter } from './adapters/template.adapter';
import { statsReportAdapter } from './adapters/stats-report.adapter';

// =============================================================================
// IMPORT ADAPTER REGISTRY
// =============================================================================

const registry = new Map<string, ImportAdapter>([
  ['contact', contactAdapter],
  ['custom_data', customDataAdapter],
  ['campaign_automation', campaignAutomationAdapter],
  ['campaign_bulk', campaignBulkAdapter],
  ['template', templateAdapter],
  ['stats_report', statsReportAdapter],
]);

/**
 * Get an import adapter by type
 * @throws Error if adapter type is not registered
 */
export function getImportAdapter(type: string): ImportAdapter {
  const adapter = registry.get(type);
  if (!adapter) {
    throw new Error(`Unknown import type: ${type}`);
  }
  return adapter;
}

/**
 * Register a new import adapter
 */
export function registerImportAdapter(adapter: ImportAdapter): void {
  registry.set(adapter.type, adapter);
}

/**
 * Check if an adapter type is registered
 */
export function hasImportAdapter(type: string): boolean {
  return registry.has(type);
}

/**
 * Get all registered adapter types
 */
export function getRegisteredAdapterTypes(): string[] {
  return Array.from(registry.keys());
}
